import LeftPanelOverlayContainer from "components/LeftPanelOverlay/LeftPanelOverlayContainer";

export default LeftPanelOverlayContainer;